import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="bg-white shadow-sm fixed w-full z-50" data-id="element-529">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-530">
        <div className="flex items-center justify-between h-16" data-id="element-531">
          <div className="flex items-center" data-id="element-532">
            <div className="flex-shrink-0" data-id="element-533">
              <span className="font-serif text-2xl font-bold text-limestone-800 tracking-wider" data-id="element-534">
                EPA
              </span>
            </div>
            <div className="hidden md:block" data-id="element-535">
              <div className="ml-10 flex items-baseline space-x-4" data-id="element-536">
                <a href="#why-join" className="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-limestone-800 transition" data-id="element-537">
                  Why Join
                </a>
                <a href="#calculator" className="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-limestone-800 transition" data-id="element-538">
                  My Revenue Calculator
                </a>
                <a href="#technology" className="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-limestone-800 transition" data-id="element-539">
                  Technology
                </a>
                <a href="#perks" className="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-limestone-800 transition" data-id="element-540">
                  Perks
                </a>
                <a href="#community" className="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-limestone-800 transition" data-id="element-541">
                  Community
                </a>
              </div>
            </div>
          </div>
          <div className="hidden md:block" data-id="element-542">
            <a href="#masterclass-curriculum" className="bg-limestone-700 hover:bg-limestone-800 text-white font-medium py-2 px-4 rounded-md transition" data-id="element-543">
              Join Our Masterclasses
            </a>
          </div>
          <div className="-mr-2 flex md:hidden" data-id="element-544">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-limestone-800 hover:bg-limestone-50 focus:outline-none" data-id="element-545">
              <span className="sr-only" data-id="element-546">Open main menu</span>
              {isOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-547" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-548" />}
            </button>
          </div>
        </div>
      </div>
      {isOpen && <div className="md:hidden" data-id="element-549">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg" data-id="element-550">
            <a href="#why-join" className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-limestone-800" data-id="element-551">
              Why Join
            </a>
            <a href="#calculator" className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-limestone-800" data-id="element-552">
              My Revenue Calculator
            </a>
            <a href="#technology" className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-limestone-800" data-id="element-553">
              Technology
            </a>
            <a href="#perks" className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-limestone-800" data-id="element-554">
              Perks
            </a>
            <a href="#community" className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-limestone-800" data-id="element-555">
              Community
            </a>
            <a href="#masterclass-curriculum" className="mt-2 w-full bg-limestone-700 hover:bg-limestone-800 text-white font-medium py-2 px-4 rounded-md transition text-center" data-id="element-556">
              Join Our Masterclasses
            </a>
          </div>
        </div>}
    </nav>;
};